import { convertGregorianDateToPersian } from "utils/helpers";
import { v4 as uuidv4 } from "uuid";

type paymentObj<T> = {
    branch_title: string;
    branch_id: number;
    items: T[];
};

type MergedObj<T> = T & { id: string };

export const getObjectOfTable = <T>(
    data: paymentObj<T>[],
    type?: string
): MergedObj<T>[] => {
    let tempArray: MergedObj<T>[] = [];
    data?.forEach((obj) => {
        obj.items.forEach((item) => {
            tempArray.push({
                ...item,
                branch_title: obj.branch_title,
                ...(!!type && { branch_id: obj.branch_id, type }),
                id: uuidv4(),
            });
        });
    });
    return tempArray;
};

export const convertDate = (date: any) => {
    const formatDate = date.split(",").map((item: string) => {
        return convertGregorianDateToPersian(item, "jM-jD").replaceAll(
            "-",
            "/"
        );
    });
    return `از ${formatDate[0]} تا ${formatDate[1]}`;
};
